var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 28,
    viewBox: "0 0 23 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4466 4.90431L10.5225 4.90041C6.13356 4.89001 2.32344 8.42212 2.29326 12.7004V17.6274C2.29326 18.6544 2.16201 19.6567 1.59633 20.5108L1.21965 21.0802C0.646096 21.9434 1.26296 23.1004 2.29326 23.1004H20.7073C21.7376 23.1004 22.3532 21.9434 21.7809 21.0802L21.4042 20.5108C20.8399 19.6567 20.7073 18.6531 20.7073 17.6261V12.7017C20.6548 8.42212 16.8355 4.91471 12.4466 4.90431V4.90431Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 9C8.16667 9.16667 6 10.2 6 13",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4374 23.0996C15.4374 24.134 15.0225 25.1259 14.2841 25.8573C13.5457 26.5887 12.5442 26.9996 11.4999 26.9996C10.4557 26.9996 9.45416 26.5887 8.71575 25.8573C7.97733 25.1259 7.5625 24.134 7.5625 23.0996",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5009 1C12.1971 1 12.8648 1.27393 13.3571 1.76152C13.8493 2.24912 14.1259 2.91044 14.1259 3.6V4.9H8.87598V3.6C8.87598 2.91044 9.15253 2.24912 9.64481 1.76152C10.1371 1.27393 10.8047 1 11.5009 1Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.23db70247f776219ca4762a0194ef921.svg";
export { ForwardRef as ReactComponent };